import toGoogleMapsPoint from '@/fields/utils/toGoogleMapsPoint';

export default function toGoogleMapsPath(coordinates: number[][]): google.maps.MVCArray<google.maps.LatLng> {
  return new google.maps.MVCArray(coordinates.map(toGoogleMapsPoint));
}
